import type { Address } from "viem"
import type { Config } from "wagmi"
import { readContract } from "@wagmi/core"
import { formatUnits } from "viem"

import { voterAbi } from "@/domains/abis"
import { LcAddress } from "@/domains/core"

import type { IGaugeOnChainTransport } from "./interfaces"

export type GaugeOnChainTransportAddresses = {
  voter: Address
}

export class GaugeOnChainTransport implements IGaugeOnChainTransport {
  constructor(
    private readonly config: Config,
    private readonly chainId: number,
    private readonly addresses: GaugeOnChainTransportAddresses,
  ) {}

  async fetchGaugeVoteData(gaugeAddress: LcAddress): Promise<{ votes: string; votesPercent: string } | undefined> {
    try {
      // Read weights (votes) for the gauge
      const weightsResult = await readContract(this.config, {
        address: this.addresses.voter,
        abi: voterAbi,
        functionName: "weights",
        args: [gaugeAddress.toViemAddress()],
        chainId: this.chainId,
      })

      const votes = formatUnits(weightsResult as bigint, 18)

      // Read totalWeight to calculate votesPercent
      const totalWeightResult = await readContract(this.config, {
        address: this.addresses.voter,
        abi: voterAbi,
        functionName: "totalWeight",
        chainId: this.chainId,
      })

      const totalWeight = formatUnits(totalWeightResult as bigint, 18)
      const votesPercent = totalWeight === "0" ? "0" : ((Number(votes) / Number(totalWeight)) * 100).toString()

      return {
        votes,
        votesPercent,
      }
    } catch (error) {
      console.error("Failed to fetch gauge vote data:", error)
      return undefined
    }
  }
}
